<template>
  <div>
    <b-row>
      <b-col cols="12">
        <goals-filter :get-report-data="getData" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Toplam Hedef"
            color="success"
            icon="CheckCircleIcon"
            :value="rates.grandTotal.goals"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Toplam Satış"
            color="info"
            icon="RepeatIcon"
            :value="rates.grandTotal.sales"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Gerçekleşme Oranı"
            color="warning"
            icon="PercentIcon"
            :value="rates.grandTotal.rates"
            prefix="%"
          />
        </b-col>
        <b-col
          v-for="rate in rates.data"
          :key="rate.id"
          cols="12"
          md="6"
        >
          <second-ratio-card
            :card-title="rate.title"
            title="Satış Adet"
            second-title="Satış Hedefi"
            :swap-value="rate.goals"
            :value="rate.sales"
            :rate="[rate.rates]"
            rate-title="Oran"
          />
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import GoalsFilter from '@/views/Sales/FilterCards/GoalsFilter.vue'
import SecondRatioCard from '@/layouts/components/ReportCards/SecondRatioCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'

export default {
  name: 'SaleGoals',
  components: {
    LoadingCard,
    SecondRatioCard,
    GoalsFilter,
    DefaultCard,
    BRow,
    BCol,
  },
  computed: {
    loading() {
      return this.$store.getters['saleGoalsReports/loading']
    },
    rates() {
      return this.$store.getters['saleGoalsReports/rates']
    },
    ratesParams() {
      return this.$store.getters['saleGoalsReports/ratesParams']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('saleGoalsReports/getRates', this.ratesParams)
    },
  },
}
</script>
